import { Injectable } from "@angular/core";

import * as moment from 'moment-timezone';
import { Subject } from "rxjs";

@Injectable()
export class SlotDataService {
    date: string;
    time: string;
    allowCancellation : boolean;
    allowRescheduling : boolean;
    calenderData: any;
    appointmentCode: string;
    appointmentDetail: any;
    formattedDateTime: string;
    hasReschedule: boolean;
    timezoneOffset: number;
    leadUserInfo: any;
    timezone:string = "";
    availableTimeZonesList:any = [];
    public logoUrl:string="";
    public companyName:string="";
    public uiFooter: string = "";
    public savedAppointmentSlot: any = {};

    constructor() {
        var date = new Date();
        this.calenderData = {
            location: '',
            description: '',
            title: '',
            startDate: '',
            endDate: ''
        }
    }
    
    /**
     * function to set logo_url and comapany_name
     */
    setLogoUrlAndCompanyName(logoUrl, companyName){
        if(logoUrl){
            this.logoUrl = logoUrl;
        }
        if(companyName){
            this.companyName = companyName;
        }
    }

    getLogoUrl(){
        return this.logoUrl;
    }

    getCompnayName(){
        return this.companyName;
    }

    getUiFooter(){
        return this.uiFooter;
    }

    getDateTimeUtc(date, time){
        var onlyDate = date.split('T')[0];
        var fullDate = onlyDate + "T" + time+"Z";
        var m = moment(fullDate, "YYYY-MM-DDThh:mm:ss").utc();
        return {
             date: m.format("YYYY-MM-DD")+'T00:00:00Z',
             time: m.format("h:mm:ss")
        }

    }

    public bookAppointment: Subject<any> = new Subject();
    setBookAppointment(data) {
      this.bookAppointment.next(data);
    }

    setDateTime(date, time) {
        this.date = date;
        this.time = time;
        
        var m = moment(date, "YYYY-MM-DDTh:mm:ssZ");
        this.calenderData.startDate = m.format("YYYYMMDDT") + moment(time, "HH:mm:ss").format("HHmmss")
        m = moment(this.calenderData.startDate, "YYYYMMDDThhmmss").add(this.appointmentDetail.Duration, 'minutes');
        this.calenderData.endDate = m.format("YYYYMMDDTHHmmss");
        // this.formattedDateTime = moment(
        //     this.calenderData.startDate, "YYYYMMDDThhmmss"
        // ).format('dddd, MMMM Do, YYYY h:mma');
        this.formattedDateTime = moment(
            this.calenderData.startDate, "YYYYMMDDTHHmmss"
        ).format();
    }

    getDateTime() {
        return {
            date: this.date, 
            time: this.time
        };
    }

    setAppointmentCode(appointmentCode) {
        this.appointmentCode = appointmentCode;
    }

    getAppointmentCode(){
        return this.appointmentCode;
    }

    getData() {
        return this.calenderData;
    }

    setAppointMentDetail(data) {
        this.appointmentDetail = data;
        if (!this.leadUserInfo){
            this.leadUserInfo = this.appointmentDetail.LeadUser;
        }
        this.calenderData.description = data.AppointmentTypeDescription;
        this.calenderData.title = data.AppointmentTypeName;
        
        if (data.IsBooked) {
            var date, time;
            data.BookingSlots.forEach((item) => {
                date = item.Date;
                item.TimeSlots.forEach((slotsItem) => {
                    time = slotsItem.Time;
                })
            })
            this.setDateTime(date, time);
            this.appointmentDetail.ConfirmationText = "Je hebt al een afspraak gemaakt voor deze uitnodiging.";
        }
    }

    getAppointMentDetail() {
        return this.appointmentDetail;
    }

    getLeadUserInfo() {
        return this.leadUserInfo;
    }
}





// WEBPACK FOOTER //
// ./src/app/slots/slots-data.service.ts